import { api as apiExports } from "../api";

const { Interceptor: api, routes } = apiExports;

export const getAllApplicants = async (payload, headers) => {
  const { params } = payload;
  return await api.get(
    routes.hr.get_applicant.concat(params),
    payload,
    headers
  );
};

export const getAllEmployees = async (payload, headers) => {
  const { params } = payload;
  return await api.get(
    routes.hr.get_employee.concat(params),
    payload,
    headers
  );
};

export const getAllUser = async () => {
  return await api.get(
    routes.hr.get_employee,

  );
};
// getAttributeData
export const getHardwareAttribute = async (payload, headers) => {
  return await api.get(
    routes.hardware.getAttributeData,
    payload,
    headers
  );
};

export const getIncidentTypes = async (payload, headers) => {
  return await api.get(
    routes.hr.incident_type,
    payload,
    headers
  );
};


export const getClassifications = async (payload, headers) => {
  return await api.get(
    `${routes.hr.classification}/${payload}`,
    payload,
    headers
  );
};

export const closeApplicant = async ({ id, comment }) => {

  return await api.put(
    routes.hr.close_applicant + id,
    { closing_comments: comment },
  );
};


export const getAllApplicantsByID = async (payload, headers) => {
  const { id } = payload;

  return await api.get(
    routes.hr.get_applicant_by_id.concat(id),
    payload,
    headers
  );
};
export const updateApplicant = async (payload, headers) => {
  const { id } = payload;

  return await api.put(
    routes.hr.updateApplicant.concat(id),
    payload,
    headers
  );
};


export const getAllApplicantsByIDApplicantLogin = async (payload, headers) => {
  const { id } = payload;

  return await api.get(
    routes.hr.get_applicant_by_id_applicant_login.concat(id),
    payload,
    headers
  );
};


export const getAllApplicantsByName = async (payload, headers) => {
  const { name, status, params } = payload;

  return await api.get(
    routes.hr.get_applicants_by_name
      .concat(`?name=${name}`)
      .concat(status ? "&status=1" : "")
      .concat(params),
    payload,
    headers
  );
};

export const getAllApplicantsByNameNewHireQueue = async (payload, headers) => {
  const { name } = payload;

  return await api.get(
    routes.employee.search_applicants
      .concat(`?name=${name}`),
    payload,
    headers
  );
};

export const step1 = async (payload, headers) => {
  return await api.post(routes.hr.step1, payload, headers);
};

export const step2 = async (payload, headers) => {
  return await api.post(routes.hr.step2, payload, headers);
};

export const reject = async (payload, headers) => {
  return await api.post(routes.hr.reject, payload, headers);
};

export const get_tickets = async (payload, headers) => {
  return await api.get(routes.hr.get_tickets_and_allerts, payload, headers);
};

export const listTicketByCategory = async (payload, headers) => {

  const { roleId, params } = payload;
  return await api.get(
    routes.hr.list_tickets_and_alerts_by_category.concat(roleId, params),
    payload,
    headers
  );
};

export const get_tickets_by_id = async (payload, headers) => {
  const { id } = payload;

  return await api.get(routes.hr.get_ticket_by_id.concat(id), payload, headers);
};

export const update_tickets = async (payload, headers) => {
  const { id } = payload;

  return await api.put(routes.hr.update_tickets.concat(id), payload, headers);
};

export const HowDidYouHere = async (payload, headers) => {
  const { id } = payload;
  delete payload.id

  return await api.put(routes?.hr?.EditHowDidYouHere.concat(id), payload, headers);
};

// dropdowns
export const getPositionLevel = async (payload, headers) => {
  return await api.get(routes.hr.position_level, payload, headers);
};

export const get_job_categories = async (payload, headers) => {
  return await api.get(routes.hr.get_job_categories, payload, headers);
};

export const location = async (payload, headers) => {
  return await api.get(routes.hr.location, payload, headers);
};

export const pay_type = async (payload, headers) => {
  return await api.get(routes.hr.paytype, payload, headers);
};

export const department = async (payload, headers) => {
  return await api.get(routes.hr.department, payload, headers);
};

export const subDepartment = async (payload, headers) => {
  return await api.get(routes.hr.subDepartment.concat(payload?.id), payload, headers);
};

export const getEmployee = async (payload, headers) => {
  const { id, status } = payload;

  return await api.get(
    `${routes.hr.get_employee_by_id}${id}` +
    (status !== undefined || status != null
      ? status === true
        ? "?status=1"
        : "?status=2"
      : ""),
    payload,
    headers
  );
};

export const getMyEmployee = async (payload, headers) => {
  const { id, status } = payload;

  return await api.get(
    `${routes.hr.get_employee_by_id}my`,
    payload,
    headers
  );
};

export const updateEmployeeAddress = async (payload, headers) => {
  return await api.put(routes.hr.update_employee_address, payload, headers);
};

export const additionalFiles = async (payload, headers) => {
  const { id, formData } = payload;
  return await api.put(
    routes.hr.additional_files_uplaod.concat(id),
    formData,
    headers
  );
};
export const additionalFilesEMP = async (payload, headers) => {
  const { id, formData } = payload;
  return await api.put(
    routes.hr.additional_files_uplaod_emp.concat(id),
    formData,
    headers
  );
};

export const additionalFilesIncident = async (payload, headers) => {
  const { incidentId, formData } = payload;
  return await api.put(
    routes.hr.additional_files_uplaod_incident.concat(incidentId),
    formData,
    headers
  );
};

export const getHardwareType = async (payload, headers) => {
  return await api.get(routes.hr.get_hardware_type, payload, headers);
};

export const getHardwareNames = async (payload, headers) => {
  return await api.get(routes.employee.getHardwareNames.concat(payload), payload, headers);
};

export const get_employee_hardware = async (payload, headers) => {
  const { id } = payload;

  if (id) {

    return await api.get(
      routes.hr?.get_employee_data?.concat(id),
      payload,
      headers
    );
  }
}

export const getHardwareName = async (payload, headers) => {
  return await api.get(routes.hr.get_hardware_Name, payload, headers);
};
export const on_add_hardware = async (body) => {
  return await api.post(routes?.hr.add_hardware, body)
}
export const getCertificate = async (payload, headers) => {
  const { id } = payload;
  return await api.get(routes.hr.get_certificate.concat(id), payload, headers);
};


export const getCertificateType = async (payload, headers) => {
  return await api.get(
    routes.hr.get_certificate_type,
    // payload,
    headers
  );
};
export const onUpdateStatusList = async (payload, headers) => {
  return await api.get(routes.hr.update_List, payload, headers);
};

export const deleteEmployeeDocument = async ({ id, name }, payload, headers) => {
  return await api.delete(`${routes.employee.deleteDocument}?id=${id}&name=${name}`, payload, headers);
};


export const onUpdateCompCodeList = async (payload, headers) => {
  return await api.get(routes.hr.compcode_List, payload, headers);
};

export const onUpdatePayCodeList = async (payload, headers) => {
  return await api.get(routes.hr.payCode_List, payload, headers);
};

export const onUpdateUID = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.employee.onUpdateUID.concat(id),
    { uid: payload.uid },
    headers
  );
}

//Badge Notification

export const updateEmployeeDetails = async (payload, headers) => {
  const { id } = payload;
  return await api.put(routes.hr.update_Contact.concat(id), payload, headers);
};

export const onUpdateStatusModal = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.hr.onUpdate_statusModal.concat(id),
    payload,
    headers
  );
};

export const updateEmergencyContactApi = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.hr.update_emergency_contact.concat(id),
    payload,
    headers
  );
};
export const updateEditHireModalApi = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.hr.update_Hire_Date.concat(id),
    payload,
    headers
  );
};
export const updateEditTerminateApi = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.hr.update_Edit_Terminate_Api,
    payload,
    headers
  );
};

export const updateEmergencyContactAdmin = async (payload, headers) => {
  const { id } = payload;

  return await api.put(
    routes.hr.update_emergency_contact_admin,
    payload,
    headers
  );

};

export const updatePosition = async (payload, headers) => {
  // const { id } = payload;
  return await api.put(routes.hr.update_position, payload, headers);
};

export const onUpdateRehireModal = async (payload, headers) => {
  const { id } = payload;
  return await api.put(
    routes.hr.onUpdate_RehireModal.concat(id),
    payload,
    headers
  );
};

export const editPosition = async (payload, headers) => {
  const { id } = payload;
  return await api.put(routes.hr.edit_position.concat(id), payload, headers);
};

export const updatePay = async (payload, headers) => {
  return await api.put(routes.hr.update_pay, payload, headers);
};

export const editPay = async (payload, headers) => {
  let { id } = payload;
  return await api.put(routes.hr.edit_pay.concat(id), payload, headers);
};

export const terminateEmployee = async (payload, headers) => {
  return await api.post(routes.hr.terminate, payload, headers);
};

export const ticketCount = async (payload, headers) => {
  const { id } = payload;
  return await api.get(routes.hr.onUpdateNotification.concat(id), payload, headers);
}
export const NewHirequeCount = async (headers) => {
  return await api.get(routes.hr.onUpdateNewHireQueCount, headers);
}
// @returns {void}
//  * @param {string} payload.id - Employee Id
//

export const isEmployee = async (payload, headers) => {
  return await api.post(routes.hr.employee.concat(payload?.id), {}, headers);

}

export const rejectedReason = async (payload, headers) => {

  return await api.get(`${routes.hr.get_rejected_reason}/${payload}`)
}

export const createIncident = async (payload, headers) => {
  return await api.post(routes.hr.create_updateIncident, payload, headers);
};
export const incidentFields = async (payload, headers) => {
  return await api.get(routes.employee.incident_fields, payload, headers);
}

export const incidentFieldsByID = async (payload, headers) => {
  return await api.get(`${routes.employee.incident_fieldsByID}/${payload}`, payload, headers);
}
export const getRolesPayroll = async (payload, headers) => {
  return await api.get(`${routes.employee.getRolesPayroll}`, payload, headers);
}

export const incidentUpdate = async ({ id, values }, headers) => {

  return await api.put(`${routes.hr.incident_update}/${id}`, values, headers);
};

export const finalizeIncident = async ({ id, values }, headers) => {
  return await api.put(`${routes.hr.finalize_incident}/${id}`, values, headers);
};

export const reopenIncident = async (payload, headers) => {
  return await api.put(`${routes.hr.reopen_incident}/${payload}`, payload, headers);
};
export const EmployeeHardware = async (id, payload, headers) => {
  return await api.get(`${routes.employee.EmployeeHardware}/${id}`, payload, headers);
}
